const SUPPRESSED_ERRORS = [
  "com.apple.authenticationservices.webauthenticationsession error 3",
  "canceledlogin"
];

const isSuppressedExpressCheckoutError = error => {
  if (!error) return false;

  const message = typeof error === "string" ? error : error?.message || "";
  const lower = message.toLowerCase();

  return SUPPRESSED_ERRORS.some(pattern => lower.includes(pattern));
};

export default isSuppressedExpressCheckoutError;
